/** Normalize Stripe Connect account id onto profile for UI (camelCase + merchant API). */

export function firstNonEmptyStripeId(
  ...candidates: Array<string | null | undefined>
): string | undefined {
  for (const c of candidates) {
    if (typeof c === 'string' && c.trim() !== '') return c.trim();
  }
  return undefined;
}

export function mergeStripeConnectIdIntoProfile(payload: {
  profile: {
    stripeConnectId?: string;
    stripe_connect_id?: string;
  };
  roles?: string[];
  otherProfiles?: { merchant?: { stripeConnectId?: string; stripe_connect_id?: string } };
} & Record<string, unknown>): void {
  const p = payload.profile;
  const m = payload.otherProfiles?.merchant;
  const merged = firstNonEmptyStripeId(
    p.stripeConnectId,
    p.stripe_connect_id,
    (payload as { stripeConnectId?: string }).stripeConnectId,
    (payload as { stripe_connect_id?: string }).stripe_connect_id,
    m?.stripeConnectId,
    m?.stripe_connect_id
  );
  if (merged) {
    p.stripeConnectId = merged;
  }
}

export async function mergeStripeConnectFromMerchantStatus(
  payload: {
    profile: { stripeConnectId?: string };
    roles?: string[];
  },
  getStatus: () => Promise<{ stripeConnectId: string | null }>
): Promise<void> {
  if (
    payload.profile.stripeConnectId ||
    !Array.isArray(payload.roles) ||
    !payload.roles.includes('MERCHANT')
  ) {
    return;
  }
  try {
    const sc = await getStatus();
    if (sc.stripeConnectId) {
      payload.profile.stripeConnectId = sc.stripeConnectId;
    }
  } catch (e) {
    console.warn('Could not load merchant Stripe Connect status for profile:', e);
  }
}
